require('./brokerTransferPensionPlansInternalStep3.scss');

const PropTypes = require('prop-types');

// @Utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @vendors
const React = require('react');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @Components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { AmountInput } = require('commonsComponents/amountInput');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @Constants
const {
    BROKER_TRANSFER_PENSION_PLAN_TYPE_TOTAL_OPTION,
    BROKER_TRANSFER_PENSION_PLAN_TYPE_PARTIAL_OPTION,
    BROKER_TRANSFER_PENSION_PLAN_FISC_A_OPTION,
    BROKER_TRANSFER_PENSION_PLAN_FISC_B_OPTION,
    BROKER_TRANSFER_PENSION_PLAN_FISC_C_OPTION,
    BROKER_TRANSFER_PENSION_PLAN_INTERNAL_FRACTION_LENGTH_AMOUNT_VALUE,
    BROKER_TRANSFER_PENSION_PLAN_INTERNAL_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH,
    BROKER_TRANSFER_PENSION_PLAN_ERROR_BELOW_MIN
} = require('constants/index');

class BrokerTransferPensionPlansInternalStep3 extends React.Component {

    componentDidMount() {
        const { setAmountRange } = this.props;
        setAmountRange();
    }

    buildTypeRadioButtonsBlock() {
        const {
            immStep,
            handleChangeTransferTypeOption
        } = this.props
        const selectedTransferTypeOption = immStep.get('selectedTypeOption');

        return (
            <RadioButtonGroup
                idPrefix="brokerTraspassBetweenMyPlansTransferType"
                name="transfer-type"
                selectedValue={selectedTransferTypeOption}
                onChange={handleChangeTransferTypeOption}
                className="broker-transfer-pension-plans-internal-step3__transfer-type-radio-buttons"
                isHorizontal={true}
            >
                <RadioButton
                    label={formatText('brokerTraspassBetweenMyPlans-step3Total')}
                    value={BROKER_TRANSFER_PENSION_PLAN_TYPE_TOTAL_OPTION}
                    className="broker-transfer-pension-plans-internal-step3__radio-button"
                />
                <RadioButton
                    label={formatText('brokerTraspassBetweenMyPlans-step3Partial')}
                    value={BROKER_TRANSFER_PENSION_PLAN_TYPE_PARTIAL_OPTION}
                    className="broker-transfer-pension-plans-internal-step3__radio-button"
                />
            </RadioButtonGroup>
        );
    }

    buildFiscalizationRadioButtonsBlock() {
        const {
            immStep,
            handleChangeFiscalizationOption
        } = this.props;
        const selectedFiscalizationOption = immStep.get('selectedFiscOption');
        const partialFiscOptionEnabled = immStep.get('partialFiscOptionEnabled');

        return (
            <RadioButtonGroup
                idPrefix="brokerTraspassBetweenMyPlansFiscalizationOption"
                name="fiscalization-option"
                selectedValue={selectedFiscalizationOption}
                onChange={handleChangeFiscalizationOption}
                className="broker-transfer-pension-plans-internal-step3__fisc-radio-buttons"
            >
                <RadioButton
                    label={formatText('brokerTraspassBetweenMyPlans-step3Disc1')}
                    value={BROKER_TRANSFER_PENSION_PLAN_FISC_A_OPTION}
                    disabled={!partialFiscOptionEnabled}
                />
                <RadioButton
                    label={formatText('brokerTraspassBetweenMyPlans-step3Disc2')}
                    value={BROKER_TRANSFER_PENSION_PLAN_FISC_B_OPTION}
                    disabled={!partialFiscOptionEnabled}
                />
                <RadioButton
                    label={formatText('brokerTraspassBetweenMyPlans-step3Disc3')}
                    value={BROKER_TRANSFER_PENSION_PLAN_FISC_C_OPTION}
                />
            </RadioButtonGroup>
        );

    }

    buildAmountInput() {
        const {
            handleAmountChange,
            immStep
        } = this.props;
        const selectedTransferType = immStep.get('selectedTypeOption');
        const minimumAmount = immStep.get('minimumAportation');
        const selectedAmount = immStep.get('partialAportation') ? immStep.get('partialAportation') : minimumAmount;

        const plainAmountObject = getPlainAmountObject(immStep.get('minimumAportation'));
        const minimumAportationObject = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(immStep.get('minimumAportation'))}/>
        );
        const language = getLanguage();
        let input;

        if(selectedTransferType == BROKER_TRANSFER_PENSION_PLAN_TYPE_PARTIAL_OPTION) {
            const errorMsg = immStep.get('errorType') === BROKER_TRANSFER_PENSION_PLAN_ERROR_BELOW_MIN ?
                'brokerTraspassBetweenMyPlans-step3InputErrorMin' : null;
            const inputClassName = errorMsg === 'brokerTraspassBetweenMyPlans-step3InputErrorMin' ?  
                "broker-transfer-pension-plans-internal-step3__input-amount-error" : "broker-transfer-pension-plans-internal-step3__input-amount";
            const formattedAportation = !errorMsg ? (
                <FormattedTextWithComponents
                    value="brokerTraspassBetweenMyPlans-step3MinimunAportation"
                    injectedComponents={[
                        minimumAportationObject
                    ]}
                />
            ) : null;
            input = (
                <div className={inputClassName}>
                    <AmountInput
                        min={0}
                        amount={selectedAmount.get('amount')}
                        callback={handleAmountChange}
                        error={immStep.get('inputError')}
                        errorMsg={formatText(errorMsg)}
                        inlineError={true}
                        language={language}
                        maxFractionLength={BROKER_TRANSFER_PENSION_PLAN_INTERNAL_FRACTION_LENGTH_AMOUNT_VALUE}
                        maxBackEndFractionLength={BROKER_TRANSFER_PENSION_PLAN_INTERNAL_FRACTION_LENGTH_AMOUNT_VALUE}
                        maxIntegerLength={BROKER_TRANSFER_PENSION_PLAN_INTERNAL_PLAN_MAXIMUN_INTEGER_AMOUNT_LENGTH}
                    />
                    {formattedAportation}
                </div>
            );
        }

        return input;
    }

    render(){
        const { immStep } = this.props;
        const selectedTransferType = immStep.get('selectedTypeOption');
        const footerText =  selectedTransferType !== BROKER_TRANSFER_PENSION_PLAN_TYPE_PARTIAL_OPTION ? (
            <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step3FooterPartial" />
        ) : (
            <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step3Footer" />
        );
        return (
            <div>
                <div className="broker-transfer-pension-plans-internal-step3">
                    <OKBoxTitle
                        className="broker-transfer-pension-plans-internal-step3__title"
                        value={formatText('brokerTraspassBetweenMyPlans-step3Title')} />
                    <div className="broker-transfer-pension-plans-internal-step3__info">
                        <FormattedText value="brokerTraspassBetweenMyPlans-step3TraspassTypeSelect" />
                    </div>
                    <div className="broker-transfer-pension-plans-internal-step3__transfer-type-select">
                        <div className="broker-transfer-pension-plans-internal-step3__transfer-type-select">
                            <FormattedText value="brokerTraspassBetweenMyPlans-step3TraspassType"/>
                        </div>
                        <div className="broker-transfer-pension-plans-internal-step3__transfer-type-block">
                            {this.buildTypeRadioButtonsBlock()}
                            {this.buildAmountInput()}
                        </div>
                    </div>
                    <div className="broker-transfer-pension-plans-internal-step3__info--fisc">
                        <FormattedText value="brokerTraspassBetweenMyPlans-step3Fisc" />
                    </div>
                    {this.buildFiscalizationRadioButtonsBlock()}
                </div>
                <div className="broker-transfer-pension-plans-internal-step3__footer">
                    <OKMessage type="informative">
                        {footerText}
                    </OKMessage>
                </div>
            </div>
        )
    }
}

BrokerTransferPensionPlansInternalStep3.propTypes = {
    immStep: PropTypes.object.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleChangeTransferTypeOption: PropTypes.func.isRequired,
    handleChangeFiscalizationOption: PropTypes.func.isRequired,
    setAmountRange: PropTypes.func.isRequired
}

module.exports = BrokerTransferPensionPlansInternalStep3;
